export default "__VITE_ASSET__b732e997__"